import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import { searchBox, refinementList, configure } from 'instantsearch.js/es/widgets'
import customPagination from './algolia/pagination';
import customHits from './algolia/hits';

let apiIdentifiant = getApiIdentifiant();
let placeholderRecherche = $('.contenuPage').data('placeholder-recherche');

const indexName = getAlgoliaIndex();

const searchClient = algoliasearch(apiIdentifiant.appId, apiIdentifiant.apiId);
const search = instantsearch({
    indexName,
    searchClient,
    initialUiState: getUiState(),
    routing: {
      router: {
        /**
         * Lis la valeur du cookie pour mettre à jour les filtres Algolia.
         *
         * @see https://www.algolia.com/doc/api-reference/widgets/instantsearch/js/#widget-param-routing
         * @see https://developer.mozilla.org/en-US/docs/Web/API/document/cookie#example_2_get_a_sample_cookie_named_test2
         */
        read() {
          const cookieValue = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${indexName}=`))
            ?.split('=')[1];
          const cookieSafeValue =
            typeof cookieValue === 'undefined'
            ? {}
            : JSON.parse(decodeURIComponent(cookieValue));
          // console.debug(`Read cookie ${JSON.stringify(cookieSafeValue)} (${cookieValue})`);
          return cookieSafeValue;
        },
        /**
         * Stocke les filtres dans un cookie.
         *
         * @see https://www.algolia.com/doc/api-reference/widgets/instantsearch/js/#widget-param-routing
         * @param {*} routeState
         */
        write(routeState) {
          // On mets à jour l'URL si l'utilisateur coche un paramètre
          window.history.replaceState({}, document.title, window.location.href.split("?")[0]);
          // On utilise SameSite=Strict pour ne charger le cookie que si l'utilisateur est sur Elixens
          // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite#strict
          const cookieValue = `${indexName}=${encodeURIComponent(JSON.stringify(routeState))}; SameSite=Strict`
          // console.debug(`Wrote cookie ${JSON.stringify(routeState)} (${cookieValue})`);
          document.cookie = cookieValue;
        },
        onUpdate() {},
        createURL() {}
      },
    }
});

let widgetParameters = [
    searchBox({
        container: '#content_motscles',
        placeholder: placeholderRecherche
    }),
    customHits({
        container:  document.querySelector('#algolia_result'),
        transformItems: function(items){
            return transformItems(items)
        }
    }),
   customPagination({
       container: document.querySelector('#pagination_produit')
   }),
];

let customWidgets = getCustomWidgets();
widgetParameters = [...widgetParameters, ...customWidgets];
search.addWidgets(widgetParameters);
search.start();

/**
 *  liste des widgets et leur propriété
 * @return {array}
 * name: nom du filtre afficher sur la page
 * code: code produit d'akeneo (fait la liaison avec le champ des filtres utilisé dans le backoffice)
 * attribute: nom de l'attribut sur algolia
 */
function getAlgoliaFilter()
{
  let filters = getFilterTranslation();

  if(filters === null) return null;

  let language = $('.contenuPage').data('language');

  // selectionne la bonne traduction des filtres
  let translations;
  if(language === 'en'){
    translations = filters.en_GB
  } else {
    translations = filters.fr_FR
  }

  // créer le tableau des filres d'algolia qui va servir à generer les widgets
  let algoliaFilter = translations.map(function(item){
    return {
      name:item.label, code: item.code, attribute: item.code, options: {}
    }
  });

   return algoliaFilter;
}

function getFilterTranslation(){
  let filterTranslation = $('.json-filter-translation').html();
  if(filterTranslation.length === 0){
    return null;
  }

  let jsonfilterTranslation =  JSON.parse(filterTranslation.trim());
  return jsonfilterTranslation;
}

/**
 * retourne les identifiant de l'api d'algolia, parametrable via le backoffice
 * @return {object|null}
 */
function getApiIdentifiant()
{
  let algoliaAppId = $('.contenuPage').data('algolia-app-id');
  let algoliaApiId = $('.contenuPage').data('algolia-api-id');

  if(algoliaAppId.length === 0 || algoliaApiId.length === 0) return null;

  return {
    "appId": algoliaAppId,
    "apiId": algoliaApiId
  }
}

/**
 * Recupere l'index d'algolia selon la local du site
 * @return {string}
 */
function getAlgoliaIndex()
{
  let language = $('.contenuPage').data('language');

  if(language === 'fr'){
    return 'produits_fr';
  }

  return 'produits_en';
}

function getUiState() {
    let language = $('.contenuPage').data('language');
    var searchParam;
    const search = new URLSearchParams(window.location.search).getAll("offre")[0];
    switch (search){
        case "demande":
            document.cookie = `${indexName}={}; SameSite=Strict`
            if(language === 'fr'){
                searchParam = ["Demande de devis"];
            } else {
                searchParam = ["Quote request"];
            }
            break;
        case "eboutique":
            document.cookie = `${indexName}={}; SameSite=Strict`
            if(language === 'fr') {
                searchParam = ["E-boutique : vente en ligne"];
            } else {
                searchParam = ["E-shop: online sale"];
            }
            break;
        default:
            searchParam = false;
            break;
    }

    if (!searchParam) return {};

    if(language === 'fr'){
        return {
            produits_fr: {
                refinementList: {
                    volume: searchParam
                }
            }
        }
    }

    return {
        produits_en: {
            refinementList: {
                volume: searchParam
            }
        }
    }
}

/**
 * Crée dynamiquement des widgets pour instant search
 * @param {*object} item {name, id, attribute}
 * @param {string} widgetType, le nom du widget à crée, ex  refinementList, rangeSlider etc
 * @param {object} customOption, des options specifique que peuvent avoir des widgets
 * @return {refinementList}
 */
function createWidget(item, customOption)
{
    // ? initialisation des options
    //  defini les option obligatoire du widget
    var option = {
      container: '#' + item.id,   // l'id du block où va etre append le widget
      attribute: item.attribute,  // le nom de l'attribut d'algolia utilisé par le widget
    };

    // Ordonner les valeurs différent pour l'attribut "origin"
    if(item.attribute === "origin"){

      let sortBy = getOriginSortBy();
      if(sortBy !== null){
        option.sortBy = sortBy;
      }

    }

    // defini les parametre du template
    var requiredTemplateParams = {
      name : item.name, // le nom afficher au dessus du widget dans la vue
      id : item.id      // l'id du widget
    };

    //  ? propriété custom
    // Si le widget a des templte html custom
    if(customOption.hasOwnProperty('templates') === true){
      option.templates = customOption.templates;
    }

    // ? Crée le block du widget dans le DOM
    // Crée l'element html dans lequel va etre inseré le widget
    var template = _.template($('.template-refinement').html());
    var element = $(template(requiredTemplateParams));
    $('#accordion-filtres').append(element);

    return refinementList(option);
}

/**
 * Recupere la fonction de trie du refinement list 'Origine" à placer en parametere "sortBy" à la création du widget
 * Tri "Origine" avec les pays en premier et les Fillière en derniere, fonctionne en multilingue
 * @return {function|null}
 */
function getOriginSortBy()
{
  let pays = getPays();

  if(pays === null) return;

  return (a, b) => {

    // Si les valeurs sont toute les 2 des pays ou toutes les 2 des fillières, order par nombre
    if(pays.includes(a.name) && pays.includes(b.name) || pays.includes(a.name) === false && pays.includes(b.name) === false){
      return a.count < b.count ? 1 : -1;
    }

    // Ordonner les fillières en dernier
    if(pays.includes(a.name)){
      return -1;
    }

    return 1;
  }
}

function transformItems(items){
    return items.map(function(item){
        let newItem = item;

        // definition de l'url de l'image
        let image = $('.contenuPage').data('theme-path') + '/img/photos/image-default.jpg';
        if(item.photo_1){
            let imagePath = getImagePath(item.photo_1);
            if(imagePath !== null){
              image = imagePath;
            }
        }
        newItem.image = image;

        //definition de l'url de la fiche produit
        let ficheUrl = $('.contenuPage').data('url-fiche');
        let url;
        url = `${ficheUrl}/${item.url}`
        newItem.ficheUrl = url;

        //Logo Made In France
        let logoMIF = $('.contenuPage').data('logo-mif');
        if(item.pays && logoMIF){
          if(item.pays.length == 1 && item.pays.includes("France")){
            newItem.logoMIF = logoMIF;
          }
        }

        return newItem;
    });
}

/**
 * ? transformItems sous fonction
 * Recupere l'url de l'image des produits
 * @param {string} img
 * @return {string}
 */
function getImagePath(img)
{
  let imageSplit = img.split('/');                     // coupe la string entre chaque "/" et met chaque element dans un tableau
  let imageName = imageSplit[imageSplit.length - 1];  // recupere que le dernier element du tableau

  let imageNameSplit = imageName.split('_');         // coupe la string entre chaque "_" et met chaque element dans un tableau
  imageNameSplit.shift();                           // suprime le premier element du tableau
  let imageFullName = imageNameSplit.join('_');    // reforme la string avec "_" en separateur entre chaque element du tableau

  let domImage = $('.json-product_image').text();

  if(domImage.length === 0) return null;

  let allImagesNames = JSON.parse(domImage);   // verifie que l'image existe
  if(allImagesNames.includes(imageFullName) === false){
    return null;
  }

  let folderPath = $('.contenuPage').data('image-path'); // recupere le dossier de stockage des images
  return folderPath + imageFullName;
}

/**
 * Recupere tous les produits, la requet est effectué dans le back end et les données sont afficher dans un script/template
 * Utilisé pour generé les bon widgets selon quel donnée sont affiché sur la page
 * @return {object}
 */
function getProducts()
{
  var productDom = $('.json-product').html();
  if(productDom.length === 0){
    return null;
  }

  var product = productDom.trim();
  var jsonProduct =  JSON.parse(product);
  return jsonProduct;
}

/**
 * @return {object}
 */
function getPays()
{
  let products = getProducts();

  if(products === null) return null;

  // recupere le noms des pays
  let pays = [];
  products.forEach((product) => {
    pays = [...pays, ...product.pays];
  });

  // supprime les doublons dans le tableau
  pays = pays.filter((item, index) => pays.indexOf(item) === index && item !== undefined) ;

  return pays;
}

/**
 * Loop à travers la liste des produits et crée les widget si une des propriété du produit itéré à un widget defini
 */
function getCustomWidgets()
{
  // filtre d'algolia par default
  var algoliaFilter = getAlgoliaFilter();
  var products = getProducts();

  if(products === null || algoliaFilter === null) return [];

  let widgets = [];

  // ajoute les filtres au DOM
  algoliaFilter.forEach(function(item){

    products.some(function(product){
      // si au moins une propriété d'un produit correspond à un filtre l'ajouter (pour eviter d'ajouter des filtres vide)
      if(product.hasOwnProperty(item.code) === true){

        widgets.push(createWidget({
          name: item.name,
          id: item.code,
          attribute: item.attribute
        }, item.options));

        return true;
      }

    });

  });

  return widgets;

}


/**
 * Event clic sur la fleche à coté du nom des filtres
 */
$(document).on('click', '.filtres-header', function(){
  // recupere l'element à afficher
  let target = $(this).data('target');
  // affiche l'element avec un slide
  $(target).slideToggle("slow");
  // charge la class de l'element sur lequel l'utilisateur à cliqué
  $(this).toggleClass('collapsed');
});

